/**
 * Currency × area → composed rate-UOM table (R5 data), moved INTO calc-core per the
 * T0.2 design-doc sign-off (open question Q3 default: "CurrencyAreaMapping moves INTO
 * calc-core as data — removes a port; bulkedit needs it for sale-UOM parity anyway").
 *
 * Copied VERBATIM from marketiq-frontend
 * `projects/miq/shared-models/src/lib/constants/currency-symbols.constants.ts` L27–40
 * (`CurrencyAreaMapping`). The legacy consumers are the sale listeners
 * (`sale-auto-calc-listeners.ts` L677–679, L709, L826–839): composed rate UOMs like
 * `CurrencyAreaMapping['Great Britain Pound']['Square Foot'] === '£/SqFt'`.
 *
 * Keys are exact catalog UOM display names — case-sensitive, no trimming — matching the
 * legacy bracket-lookup behaviour byte-for-byte.
 */
export const CurrencyAreaMapping = {
  'Great Britain Pound': {
    'Square Foot': '£/SqFt',
    Hectare: '£/Hectare',
    Acre: '£/Acre',
    'Square Meter': '£/Sqm'
  },
  Euro: {
    'Square Foot': '€/SqFt',
    Hectare: '€/Hectare',
    Acre: '€/Acre',
    'Square Meter': '€/Sqm'
  }
};
/**
 * Compose a rate UOM from a whole-currency UOM name and an area UOM name (design doc §2 R5).
 *
 * Returns `CurrencyAreaMapping[currencyUom][areaUom]`, or `undefined` when either name is
 * absent from the table — the caller decides the fallback (SA6 uses `${currencyUom}/SqM`,
 * SA2/SA3 emit nothing; see `propagation-map.ts`).
 */
export function composeRateUom(currencyUom, areaUom) {
  if (currencyUom == null || areaUom == null) {
    return undefined;
  }
  return CurrencyAreaMapping[currencyUom]?.[areaUom];
}
